module.exports = ".btn-default, .btn-default:focus {\n  border-color: #d9d9d9; }\n\n.table {\n  margin-bottom: 0; }\n\n.table tr:last-child td {\n    border-bottom: none; }\n\n.panel-body {\n  padding-top: 20px;\n  padding-bottom: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/components/table-list/table-list.component.scss
// module id = ./libs/chassis-core/src/app/dashboards/components/table-list/table-list.component.scss
// module chunks = main